"use client";

import { setWorkerUrl } from "maplibre-gl";

/**
 * MapLibre v6 déduit l'URL de son worker de `import.meta.url`, que le bundler
 * ne fait pas pointer vers un fichier réel : le worker reçoit une page HTML
 * (« Failed to load module script… text/html ») et la carte reste vide, sans
 * erreur explicite.
 *
 * `scripts/copy-maplibre-worker.mjs` copie le worker dans `public/maps/maplibre/`
 * avant chaque build ; ce module en déclare l'URL. Il doit être importé avant
 * la première carte — d'où l'exécution au chargement du module plutôt qu'un
 * appel que chaque écran devrait penser à faire.
 */
setWorkerUrl("/maps/maplibre/maplibre-gl-worker.mjs");

export {};
